import type { Factory } from 'walden-fast/types/mocks';
import type { Notification } from 'walden-fast/types/notification';

const MOCK_NOTIFICATION: Notification = {
  id: '1',
  type: 'customer-service',
  description: 'Your ticket has been updated',
  date: new Date(1734516384000),
  read: false,
};

export const notificationFactory: Factory<Notification> = (overrides) => ({
  ...MOCK_NOTIFICATION,
  id: `${Math.floor(Math.random() * 1000000000)}`,
  ...overrides,
});
